import React, { createContext, useContext, useState, useEffect } from 'react';

export interface Theme {
  id: string;
  name: string;
  type: 'dark' | 'light';
  colors: {
    bg: string;
    subColor: string;
    subAlt: string;
    main: string;
    caret: string;
    text: string;
    error: string;
    errorExtra: string;
  };
}

export const themes: Theme[] = [
  // Dark themes
  {
    id: 'serika-dark',
    name: 'serika dark',
    type: 'dark',
    colors: {
      bg: '#323437',
      subColor: '#646669',
      subAlt: '#2c2e31',
      main: '#e2b714',
      caret: '#e2b714',
      text: '#d1d0c5',
      error: '#ca4754',
      errorExtra: '#7e2a33',
    },
  },
  {
    id: 'dracula',
    name: 'dracula',
    type: 'dark',
    colors: {
      bg: '#282a36',
      subColor: '#6272a4',
      subAlt: '#21222c',
      main: '#ff79c6',
      caret: '#ff79c6',
      text: '#f8f8f2',
      error: '#ff5555',
      errorExtra: '#bd2c40',
    },
  },
  {
    id: 'nord',
    name: 'nord',
    type: 'dark',
    colors: {
      bg: '#2e3440',
      subColor: '#4c566a',
      subAlt: '#3b4252',
      main: '#88c0d0',
      caret: '#88c0d0',
      text: '#eceff4',
      error: '#bf616a',
      errorExtra: '#8b4a52',
    },
  },
  {
    id: 'monokai',
    name: 'monokai',
    type: 'dark',
    colors: {
      bg: '#272822',
      subColor: '#75715e',
      subAlt: '#1e1f1c',
      main: '#a6e22e',
      caret: '#a6e22e',
      text: '#f8f8f2',
      error: '#f92672',
      errorExtra: '#c91e3a',
    },
  },
  {
    id: 'gruvbox-dark',
    name: 'gruvbox dark',
    type: 'dark',
    colors: {
      bg: '#282828',
      subColor: '#928374',
      subAlt: '#1d2021',
      main: '#fabd2f',
      caret: '#fabd2f',
      text: '#ebdbb2',
      error: '#fb4934',
      errorExtra: '#cc241d',
    },
  },
  {
    id: 'one-dark',
    name: 'one dark',
    type: 'dark',
    colors: {
      bg: '#282c34',
      subColor: '#5c6370',
      subAlt: '#21252b',
      main: '#61afef',
      caret: '#61afef',
      text: '#abb2bf',
      error: '#e06c75',
      errorExtra: '#be5046',
    },
  },
  {
    id: 'tokyo-night',
    name: 'tokyo night',
    type: 'dark',
    colors: {
      bg: '#1a1b26',
      subColor: '#565f89',
      subAlt: '#16161e',
      main: '#7aa2f7',
      caret: '#7aa2f7',
      text: '#c0caf5',
      error: '#f7768e',
      errorExtra: '#db4b4b',
    },
  },
  {
    id: 'catppuccin-mocha',
    name: 'catppuccin mocha',
    type: 'dark',
    colors: {
      bg: '#1e1e2e',
      subColor: '#6c7086',
      subAlt: '#181825',
      main: '#cba6f7',
      caret: '#cba6f7',
      text: '#cdd6f4',
      error: '#f38ba8',
      errorExtra: '#e8a2af',
    },
  },
  {
    id: 'material-darker',
    name: 'material darker',
    type: 'dark',
    colors: {
      bg: '#212121',
      subColor: '#616161',
      subAlt: '#1a1a1a',
      main: '#80cbc4',
      caret: '#80cbc4',
      text: '#eeffff',
      error: '#f07178',
      errorExtra: '#e53e3e',
    },
  },
  {
    id: 'synthwave',
    name: 'synthwave',
    type: 'dark',
    colors: {
      bg: '#2a2139',
      subColor: '#6d5a7a',
      subAlt: '#241b2f',
      main: '#ff7edb',
      caret: '#ff7edb',
      text: '#f8f8f2',
      error: '#fe4450',
      errorExtra: '#d73a49',
    },
  },
  {
    id: 'ayu-dark',
    name: 'ayu dark',
    type: 'dark',
    colors: {
      bg: '#0a0e14',
      subColor: '#4d5566',
      subAlt: '#0d1017',
      main: '#ffb454',
      caret: '#ffb454',
      text: '#b3b1ad',
      error: '#f07178',
      errorExtra: '#d95757',
    },
  },
  {
    id: 'palenight',
    name: 'palenight',
    type: 'dark',
    colors: {
      bg: '#292d3e',
      subColor: '#676e95',
      subAlt: '#1e1e2e',
      main: '#82aaff',
      caret: '#82aaff',
      text: '#a6accd',
      error: '#f07178',
      errorExtra: '#e53e3e',
    },
  },
  {
    id: 'oceanic-next',
    name: 'oceanic next',
    type: 'dark',
    colors: {
      bg: '#1b2b34',
      subColor: '#65737e',
      subAlt: '#343d46',
      main: '#6699cc',
      caret: '#6699cc',
      text: '#c0c5ce',
      error: '#ec5f67',
      errorExtra: '#d8dee9',
    },
  },
  {
    id: 'spacegray',
    name: 'spacegray',
    type: 'dark',
    colors: {
      bg: '#2c2c2c',
      subColor: '#747369',
      subAlt: '#36362e',
      main: '#fac863',
      caret: '#fac863',
      text: '#f8f8f2',
      error: '#f92672',
      errorExtra: '#ae81ff',
    },
  },
  {
    id: 'tomorrow-night',
    name: 'tomorrow night',
    type: 'dark',
    colors: {
      bg: '#1d1f21',
      subColor: '#969896',
      subAlt: '#282a2e',
      main: '#81a2be',
      caret: '#81a2be',
      text: '#c5c8c6',
      error: '#cc6666',
      errorExtra: '#a54242',
    },
  },
  {
    id: 'cobalt2',
    name: 'cobalt2',
    type: 'dark',
    colors: {
      bg: '#193549',
      subColor: '#1e4e68',
      subAlt: '#0d2a3e',
      main: '#ffc600',
      caret: '#ffc600',
      text: '#ffffff',
      error: '#ff0088',
      errorExtra: '#d73a49',
    },
  },
  {
    id: 'night-owl',
    name: 'night owl',
    type: 'dark',
    colors: {
      bg: '#011627',
      subColor: '#5f7e97',
      subAlt: '#0e293f',
      main: '#c792ea',
      caret: '#c792ea',
      text: '#d6deeb',
      error: '#ef5350',
      errorExtra: '#d73a49',
    },
  },
  {
    id: 'dark-plus',
    name: 'dark plus',
    type: 'dark',
    colors: {
      bg: '#1e1e1e',
      subColor: '#6a6a6a',
      subAlt: '#2d2d30',
      main: '#569cd6',
      caret: '#569cd6',
      text: '#d4d4d4',
      error: '#f44747',
      errorExtra: '#cd3131',
    },
  },
  {
    id: 'high-contrast-dark',
    name: 'high contrast dark',
    type: 'dark',
    colors: {
      bg: '#000000',
      subColor: '#808080',
      subAlt: '#1a1a1a',
      main: '#00ff00',
      caret: '#00ff00',
      text: '#ffffff',
      error: '#ff0000',
      errorExtra: '#cc0000',
    },
  },
  {
    id: 'shades-of-purple',
    name: 'shades of purple',
    type: 'dark',
    colors: {
      bg: '#2d2b55',
      subColor: '#6943ff',
      subAlt: '#1e1e3f',
      main: '#fad000',
      caret: '#fad000',
      text: '#a599e9',
      error: '#ec3a37',
      errorExtra: '#b91372',
    },
  },
  // Light themes
  {
    id: 'serika-light',
    name: 'serika light',
    type: 'light',
    colors: {
      bg: '#e2b714',
      subColor: '#646669',
      subAlt: '#f4f1bb',
      main: '#323437',
      caret: '#323437',
      text: '#323437',
      error: '#ca4754',
      errorExtra: '#7e2a33',
    },
  },
  {
    id: 'minimal-light',
    name: 'minimal light',
    type: 'light',
    colors: {
      bg: '#ffffff',
      subColor: '#9ca3af',
      subAlt: '#f9fafb',
      main: '#3b82f6',
      caret: '#3b82f6',
      text: '#1f2937',
      error: '#ef4444',
      errorExtra: '#b91c1c',
    },
  },
  {
    id: 'paper',
    name: 'paper',
    type: 'light',
    colors: {
      bg: '#f7f5f3',
      subColor: '#a8a29e',
      subAlt: '#faf8f5',
      main: '#059669',
      caret: '#059669',
      text: '#292524',
      error: '#dc2626',
      errorExtra: '#991b1b',
    },
  },
  {
    id: 'github-light',
    name: 'github light',
    type: 'light',
    colors: {
      bg: '#ffffff',
      subColor: '#656d76',
      subAlt: '#f6f8fa',
      main: '#0969da',
      caret: '#0969da',
      text: '#24292f',
      error: '#cf222e',
      errorExtra: '#a40e26',
    },
  },
  {
    id: 'gruvbox-light',
    name: 'gruvbox light',
    type: 'light',
    colors: {
      bg: '#fbf1c7',
      subColor: '#928374',
      subAlt: '#f9f5d7',
      main: '#b57614',
      caret: '#b57614',
      text: '#3c3836',
      error: '#cc241d',
      errorExtra: '#9d0006',
    },
  },
  {
    id: 'solarized-light',
    name: 'solarized light',
    type: 'light',
    colors: {
      bg: '#fdf6e3',
      subColor: '#93a1a1',
      subAlt: '#eee8d5',
      main: '#268bd2',
      caret: '#268bd2',
      text: '#657b83',
      error: '#dc322f',
      errorExtra: '#cb4b16',
    },
  },
  {
    id: 'one-light',
    name: 'one light',
    type: 'light',
    colors: {
      bg: '#fafafa',
      subColor: '#a0a1a7',
      subAlt: '#f0f0f1',
      main: '#4078f2',
      caret: '#4078f2',
      text: '#383a42',
      error: '#e45649',
      errorExtra: '#ca1243',
    },
  },
  {
    id: 'catppuccin-latte',
    name: 'catppuccin latte',
    type: 'light',
    colors: {
      bg: '#eff1f5',
      subColor: '#6c6f85',
      subAlt: '#e6e9ef',
      main: '#8839ef',
      caret: '#8839ef',
      text: '#4c4f69',
      error: '#d20f39',
      errorExtra: '#e64553',
    },
  },
  {
    id: 'material-light',
    name: 'material light',
    type: 'light',
    colors: {
      bg: '#fafafa',
      subColor: '#90a4ae',
      subAlt: '#f5f5f5',
      main: '#00bcd4',
      caret: '#00bcd4',
      text: '#263238',
      error: '#f44336',
      errorExtra: '#d32f2f',
    },
  },
  {
    id: 'nord-light',
    name: 'nord light',
    type: 'light',
    colors: {
      bg: '#eceff4',
      subColor: '#5e81ac',
      subAlt: '#e5e9f0',
      main: '#5e81ac',
      caret: '#5e81ac',
      text: '#2e3440',
      error: '#bf616a',
      errorExtra: '#d08770',
    },
  },
  {
    id: 'ayu-light',
    name: 'ayu light',
    type: 'light',
    colors: {
      bg: '#fafafa',
      subColor: '#8a9199',
      subAlt: '#f3f4f5',
      main: '#ff6a00',
      caret: '#ff6a00',
      text: '#5c6166',
      error: '#f51818',
      errorExtra: '#d73a49',
    },
  },
  {
    id: 'light-plus',
    name: 'light plus',
    type: 'light',
    colors: {
      bg: '#ffffff',
      subColor: '#6a737d',
      subAlt: '#f6f8fa',
      main: '#005cc5',
      caret: '#005cc5',
      text: '#24292e',
      error: '#d73a49',
      errorExtra: '#b31d28',
    },
  },
  {
    id: 'quiet-light',
    name: 'quiet light',
    type: 'light',
    colors: {
      bg: '#f5f5f5',
      subColor: '#8e8e8e',
      subAlt: '#eeeeee',
      main: '#4078f2',
      caret: '#4078f2',
      text: '#333333',
      error: '#e45649',
      errorExtra: '#ca1243',
    },
  },
  {
    id: 'winter-is-coming-light',
    name: 'winter is coming light',
    type: 'light',
    colors: {
      bg: '#ffffff',
      subColor: '#7c7c7c',
      subAlt: '#f7f7f7',
      main: '#0066cc',
      caret: '#0066cc',
      text: '#3c3c3c',
      error: '#cd3131',
      errorExtra: '#a31515',
    },
  },
  {
    id: 'atom-one-light',
    name: 'atom one light',
    type: 'light',
    colors: {
      bg: '#fafafa',
      subColor: '#a0a1a7',
      subAlt: '#f0f0f1',
      main: '#4078f2',
      caret: '#4078f2',
      text: '#383a42',
      error: '#e45649',
      errorExtra: '#ca1243',
    },
  },
  {
    id: 'tomorrow',
    name: 'tomorrow',
    type: 'light',
    colors: {
      bg: '#ffffff',
      subColor: '#8e908c',
      subAlt: '#f5f5f5',
      main: '#4271ae',
      caret: '#4271ae',
      text: '#4d4d4c',
      error: '#c82829',
      errorExtra: '#a54242',
    },
  },
  {
    id: 'intellij-light',
    name: 'intellij light',
    type: 'light',
    colors: {
      bg: '#ffffff',
      subColor: '#787878',
      subAlt: '#f5f5f5',
      main: '#0033b3',
      caret: '#0033b3',
      text: '#000000',
      error: '#ff0000',
      errorExtra: '#dc143c',
    },
  },
  {
    id: 'high-contrast-light',
    name: 'high contrast light',
    type: 'light',
    colors: {
      bg: '#ffffff',
      subColor: '#666666',
      subAlt: '#f0f0f0',
      main: '#0000ff',
      caret: '#0000ff',
      text: '#000000',
      error: '#ff0000',
      errorExtra: '#cc0000',
    },
  },
  {
    id: 'spring-light',
    name: 'spring light',
    type: 'light',
    colors: {
      bg: '#f8fff8',
      subColor: '#7fb069',
      subAlt: '#e8f5e8',
      main: '#2d5016',
      caret: '#2d5016',
      text: '#1a3409',
      error: '#d32f2f',
      errorExtra: '#b71c1c',
    },
  },
  {
    id: 'summer-light',
    name: 'summer light',
    type: 'light',
    colors: {
      bg: '#fffbf0',
      subColor: '#ff9800',
      subAlt: '#fff3e0',
      main: '#e65100',
      caret: '#e65100',
      text: '#bf360c',
      error: '#d32f2f',
      errorExtra: '#b71c1c',
    },
  },
  // Pantone Colors of the Year - Dark Themes
  {
    id: 'pantone-classic-blue-dark',
    name: 'classic blue dark',
    type: 'dark',
    colors: {
      bg: '#0f1419',
      subColor: '#34568b',
      subAlt: '#1a1f2e',
      main: '#0f4c81',
      caret: '#0f4c81',
      text: '#e8f4fd',
      error: '#ff6b6b',
      errorExtra: '#d63031',
    },
  },
  {
    id: 'pantone-ultimate-gray-dark',
    name: 'ultimate gray dark',
    type: 'dark',
    colors: {
      bg: '#2c2c2c',
      subColor: '#939597',
      subAlt: '#3a3a3a',
      main: '#f5df4d',
      caret: '#f5df4d',
      text: '#e8e8e8',
      error: '#ff7675',
      errorExtra: '#d63031',
    },
  },
  {
    id: 'pantone-very-peri-dark',
    name: 'very peri dark',
    type: 'dark',
    colors: {
      bg: '#1a1625',
      subColor: '#6667ab',
      subAlt: '#252035',
      main: '#6667ab',
      caret: '#6667ab',
      text: '#e6e6fa',
      error: '#ff6b9d',
      errorExtra: '#d63384',
    },
  },
  {
    id: 'pantone-viva-magenta-dark',
    name: 'viva magenta dark',
    type: 'dark',
    colors: {
      bg: '#2d1b2e',
      subColor: '#bb2649',
      subAlt: '#3d2b3e',
      main: '#bb2649',
      caret: '#bb2649',
      text: '#fde8ed',
      error: '#e74c3c',
      errorExtra: '#c0392b',
    },
  },
  {
    id: 'pantone-peach-fuzz-dark',
    name: 'peach fuzz dark',
    type: 'dark',
    colors: {
      bg: '#2e1f1a',
      subColor: '#ffbe98',
      subAlt: '#3e2f2a',
      main: '#ffbe98',
      caret: '#ffbe98',
      text: '#fff5f0',
      error: '#e67e22',
      errorExtra: '#d35400',
    },
  },
  {
    id: 'pantone-mocha-mousse-dark',
    name: 'mocha mousse dark',
    type: 'dark',
    colors: {
      bg: '#1e1611',
      subColor: '#ad8b73',
      subAlt: '#2e2621',
      main: '#ad8b73',
      caret: '#ad8b73',
      text: '#f5f0eb',
      error: '#d35400',
      errorExtra: '#a0522d',
    },
  },
  // Pantone Colors of the Year - Light Themes
  {
    id: 'pantone-classic-blue-light',
    name: 'classic blue light',
    type: 'light',
    colors: {
      bg: '#f0f8ff',
      subColor: '#0f4c81',
      subAlt: '#e6f3ff',
      main: '#0f4c81',
      caret: '#0f4c81',
      text: '#1a365d',
      error: '#e53e3e',
      errorExtra: '#c53030',
    },
  },
  {
    id: 'pantone-ultimate-gray-light',
    name: 'ultimate gray light',
    type: 'light',
    colors: {
      bg: '#f8f8f8',
      subColor: '#939597',
      subAlt: '#f0f0f0',
      main: '#f5df4d',
      caret: '#f5df4d',
      text: '#2d3748',
      error: '#e53e3e',
      errorExtra: '#c53030',
    },
  },
  {
    id: 'pantone-very-peri-light',
    name: 'very peri light',
    type: 'light',
    colors: {
      bg: '#f7f7ff',
      subColor: '#6667ab',
      subAlt: '#ededff',
      main: '#6667ab',
      caret: '#6667ab',
      text: '#2d3748',
      error: '#e53e3e',
      errorExtra: '#c53030',
    },
  },
  {
    id: 'pantone-viva-magenta-light',
    name: 'viva magenta light',
    type: 'light',
    colors: {
      bg: '#fef7f8',
      subColor: '#bb2649',
      subAlt: '#fce8ed',
      main: '#bb2649',
      caret: '#bb2649',
      text: '#2d3748',
      error: '#e53e3e',
      errorExtra: '#c53030',
    },
  },
  {
    id: 'pantone-peach-fuzz-light',
    name: 'peach fuzz light',
    type: 'light',
    colors: {
      bg: '#fff9f5',
      subColor: '#ffbe98',
      subAlt: '#fff0e6',
      main: '#ff8c42',
      caret: '#ff8c42',
      text: '#2d3748',
      error: '#e53e3e',
      errorExtra: '#c53030',
    },
  },
  {
    id: 'pantone-mocha-mousse-light',
    name: 'mocha mousse light',
    type: 'light',
    colors: {
      bg: '#faf7f2',
      subColor: '#ad8b73',
      subAlt: '#f5f0eb',
      main: '#8b4513',
      caret: '#8b4513',
      text: '#2d3748',
      error: '#e53e3e',
      errorExtra: '#c53030',
    },
  },
];

interface ThemeContextType {
  currentTheme: Theme;
  setTheme: (themeId: string) => void;
  themes: Theme[];
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState<Theme>(themes[0]); // Default to serika dark

  useEffect(() => {
    // Load saved theme from localStorage
    const savedThemeId = localStorage.getItem('todo-theme');
    if (savedThemeId) {
      const savedTheme = themes.find(theme => theme.id === savedThemeId);
      if (savedTheme) {
        setCurrentTheme(savedTheme);
      }
    }
  }, []);

  useEffect(() => {
    // Apply theme colors to CSS variables
    const root = document.documentElement;
    root.style.setProperty('--bg-color', currentTheme.colors.bg);
    root.style.setProperty('--sub-color', currentTheme.colors.subColor);
    root.style.setProperty('--sub-alt-color', currentTheme.colors.subAlt);
    root.style.setProperty('--main-color', currentTheme.colors.main);
    root.style.setProperty('--caret-color', currentTheme.colors.caret);
    root.style.setProperty('--text-color', currentTheme.colors.text);
    root.style.setProperty('--error-color', currentTheme.colors.error);
    root.style.setProperty('--error-extra-color', currentTheme.colors.errorExtra);
    root.style.setProperty('--colorful-error-color', currentTheme.colors.error);
    root.style.setProperty('--colorful-error-extra-color', currentTheme.colors.errorExtra);
  }, [currentTheme]);

  const setTheme = (themeId: string) => {
    const theme = themes.find(t => t.id === themeId);
    if (theme) {
      setCurrentTheme(theme);
      localStorage.setItem('todo-theme', themeId);
    }
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, setTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
}; 